import { REPORT_URL } from '@/helpers/URL'

const PrintModuleControllerEndpoint = path => {
  if (!path) {
    throw new Error('Path is required')
  }
  return `${REPORT_URL}${path}`
}

export const RUN_MULTIPLE_TEST_REPORTS = PrintModuleControllerEndpoint('runMultipleReportstest')
export const RUN_MULTIPLE_REGRESSION_REPORTS = PrintModuleControllerEndpoint(
  'runMultipleRegressionReport'
)
export const RUN_DATABASE_LOG_REPORTS = PrintModuleControllerEndpoint(
  'runStabilityDatabaseLogsReport'
)

export const RUN_LOG_REPORTS = PrintModuleControllerEndpoint('runStabilityLogsReport')
export const RUN_PROTOCOL_REPORTS = PrintModuleControllerEndpoint('runReport')

export const RUN_SCHEDULE_REPORTS = PrintModuleControllerEndpoint('runReportLMMV1')
